export default {
  title: 'Dodatki dla większego sukcesu',
  description: 'Ulepsz swój plan o dodatkowe funkcje',
  buttons: {
    continue: 'Kontynuuj',
    no_app_for_now: 'Bez aplikacji mobilnej na razie',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak, odśwież stronę lub skontaktuj się z pomocą techniczną!',
    failed_to_save_changes: 'Nie udało się zapisać zmian, skontaktuj się z pomocą techniczną!',
    changes_got_saved: 'Zmiany zostały zapisane pomyślnie!',
  },
};
